import { FC } from 'react'
import formatNumber from 'helpers/formatNumber'

type TStats = {
  label: string
  counter: number
}

const Stats: FC<TStats> = ({ counter, label }) => (
  <div className="flex flex-col gap-xxxs px-xs text-gray-900">
    <p className="text-2xl font-semibold">{formatNumber(counter)}</p>
    <span className="text-sm">{label}</span>
  </div>
)

export default Stats
